// 主人公の致命の入れ替え (2026-10-19 作者の答え・2026-10-20 から配布版 = 'lamp')。?lunaExec=old (off) = 前の配布版 (入れ替える前)。
//   作者の答え (答えるページ 10-19・q2)「普段の致命を今の最後の致命、深く一突きのモーションにしてほしくて、普段の致命はアリスの技にしたいと考えています。」
//   窓口の確認「普段の致命→今の止めの深く一突きに替える／止め (ボスを倒す最後の致命)→アリスの技に替える」→ 作者「合っています」。
//   普段の致命 = 今の止めの絵 (execute_finisher) と音 (execute) をそのまま使い、当たりは3発目の1回だけ (段階を閉じる決まりは今と同じ)。
//   止め = ゼンゼロのアリスの技 (録画 2026-10-16 00-42-14 の 1:10〜1:13) の骨組みだけを取って作り直した。
//     灰色に沈む溜め → 相手を駆け抜ける → 止めの間に裂け目が開く (火花の列・線は描かない) → 背を向けた残心 → 遅れて一点で弾ける → 銀の欠片が降る。
//   分析 = docs/research/2026-10-19-alice-finisher-reference.md。絵 = src/luna_alice_fx.ts・体の動き = scripts/author_lunaire_finisher_alice.mjs。
//   今の新しい版 (?lunaFinisher=new) と重ねた時は新しい版を優先する (こちらは今の版の上の比較)。
import type { Boss, GameState, Player } from './types'
import { finisherV2On } from './luna_finisher'
import { EXECUTE } from './balance'

//   直した版 (?lunaExec=swap2・2026-10-19 検収パック 10-19 の答え): 普段の致命を作り直した一突き (THRUST)・止めの裂け目を一続きに・弾けを早く大きく。
//     作者の答え (原文) と悪い所の洗い出し = docs/research/2026-10-19-luna-exec-swap-fix.md。swap (前の版) は比べるために残す。
//   重みを足した版 (?lunaExec=swap3・2026-10-20 作者の答え): 普段の致命は swap の深い一突き (動きはそのまま) に重い音と長い止め。
//     止めは swap2 の裂け目と弾けの上に、駆け抜けの踏ん張り (着いてから滑って止まる)・長い止め・裂け目が1本ずつ見える間・開ききってからの一瞬の静止。
//     記録 = docs/research/2026-10-20-luna-exec-weight.md。光の形 (裂け目・散る物・普段の致命の光) はお手本を作者が選んでから作る。
//   配布版 = 'lamp' (指定なし・2026-10-20 作者の答え): swap3 の重み (作者「いい」) に、常夜燈の光が漏れる光 (src/luna_lamp_leak_fx.ts)。
//     止め = お手本 a 割れたガラス・普段の致命 = お手本 b ひび。どちらも裂け目・ひびの奥から常夜燈の光が漏れる (作者のメモ)。
//     swap / swap2 / swap3 は比べるために URL 指定で残す。?lunaExec=old (または off) = 入れ替える前の配布版。
//   比較版 (DEV ?lunaExec=star・2026-10-30 作者のキーフレームの答え・docs/research/2026-10-30-luna-finisher-star.md):
//     止めの光を作り直す。裂け目の光とガラスは出さず、斬った線がパパパッと走る → 線が星型に結ぶ → 重い一撃でボスを撃破し、ボスから光が溢れる。
//     普段の致命・溜め・駆け抜け・残心は lamp のまま。
//   比較版 (DEV ?lunaExec=pierce・2026-10-30 作者と決めた設計と5コマ・docs/research/2026-10-30-luna-finisher-pierce.md):
//     すれ違いざまの一突き (筆先の軌道のような短い軌跡1本・刺した瞬間 0.1 秒止まる) → 背を向けた残心・背景がわずかに沈む静かな間
//     → 刺した一点だけ光る → 体の芯から光がこぼれる → 粒がふわっと上へ昇って消える。光はすべて常夜燈の色。ボスは膝をついたまま光になる。
export type LunaExecSwapMode = 'off' | 'swap' | 'swap2' | 'swap3' | 'lamp' | 'star' | 'pierce'
// 11-01 作者「始めて」(最後の致命の描き直し) で、作者が「めっちゃいい・消え方が最高」と言った一突きの版を配布版の既定にした。前の割れたガラスの止めは ?lunaExec=lamp。
let mode: LunaExecSwapMode = 'pierce'
export function setLunaExecSwap(raw: string | null | undefined): LunaExecSwapMode {
  mode = raw === 'old' || raw === 'off' ? 'off' : raw === 'swap' || raw === 'swap2' || raw === 'swap3' || raw === 'star' || raw === 'lamp' ? raw : 'pierce'
  return mode
}
export function lunaExecSwapMode(): LunaExecSwapMode { return mode }
export function lunaExecSwapOn(): boolean { return mode !== 'off' && !finisherV2On() }
/** 裂け目と弾けを直した版か (?lunaExec=swap2 と、その上に重みを足した swap3・配布版 lamp)。 */
export function lunaExecSwap2On(): boolean { return (mode === 'swap2' || mode === 'swap3' || mode === 'lamp' || mode === 'star' || mode === 'pierce') && lunaExecSwapOn() }
/** 重みを足した版 (?lunaExec=swap3 と配布版 lamp) か。 */
export function lunaExecSwap3On(): boolean { return (mode === 'swap3' || mode === 'lamp' || mode === 'star' || mode === 'pierce') && lunaExecSwapOn() }
/** 止めの裂け目の中心 (10-21): 配布版 = 崩れ姿の絵の不透明部分に合わせて下げる (伏せた戴冠獣で背中の上の空中に出ていた)。
 *  DEV ?execCrackPos=old = 前の位置 (足元から丈の 0.36 の高さ・立ち姿の比率のまま)。記録 docs/research/2026-10-21-hound-exec-crack-position.md。 */
let crackPosOld = false
export function setExecCrackPos(raw: string | null | undefined): void { crackPosOld = raw === 'old' }
export function execCrackPosOld(): boolean { return crackPosOld }
/** 常夜燈の光が漏れる光 (配布版 lamp) か。 */
export function lunaExecLampOn(): boolean { return (mode === 'lamp' || mode === 'star' || mode === 'pierce') && lunaExecSwapOn() }
/** 止めの光を星型に作り直した比較版 (DEV ?lunaExec=star) か。普段の致命は lamp と同じ。 */
export function lunaExecStarOn(): boolean { return mode === 'star' && lunaExecSwapOn() }
/** 星型の版の時刻 (撃破の時計)。当たりの止め 210ms の間に斬った線が走り、明けてから線が星型に結ぶ。
 *  150 からゆっくり (0.4 倍) に入るので、星は実時間で約 0.4 秒掛かったまま見え、300 で重い一撃 (ボスが砕け、光が溢れる)。 */
/** 一突きの版 (DEV ?lunaExec=pierce) か。普段の致命・溜め・駆け抜けは lamp と同じ。 */
export function lunaExecPierceOn(): boolean { return mode === 'pierce' && lunaExecSwapOn() }
/** 一突きの版の時刻。ms はすべて当たりからの見た目の時計 (aliceClockMs - ALICE.hitMs・止めの 100ms を含む)。
 *  5コマ (docs/research/2026-10-30-luna-finisher-keyframes-v2.md) の f2〜f5 に合わせた。撃破の時計はゆっくりにしない (静かな間は実時間)。 */
export const PIERCE = {
  /** 刺した瞬間の止め (設計「約0.1秒止める」)。 */
  freezeMs: 100,
  /** 刺した瞬間のボスの揺れ (この後は震えない・作者 10-30)。 */
  hitShakePx: 5, hitShakeMs: 260,
  /** 斬った跡: 刺した瞬間に出て、少し残ってから尾から閉じる (作者 10-30「表示する長さを短く」→ 10-31「短すぎて見えない・もっと切り傷みたいに」)。
   *  trailLen = 切り口の半分の長さ (人の背丈の倍率 1 の時の px)・trailAngle = 傾き (rad・振り抜いた向きへ右上がり)。 */
  trailFadeFromMs: 140, trailFadeMs: 320, trailLen: 44, trailAngle: -0.62,
  /** 背景がわずかに沈む (f2)・最後に戻る。 */
  dimInFromMs: 100, dimInMs: 450, dimAlpha: 0.3, dimOutFromMs: 2400, dimOutMs: 600,
  /** 中心がピカッと光る (f3)。弾ける (10-31 作者「小さい蛍の光みたい・破裂感が欲しい」): 一瞬大きく膨らむ光と、外へ飛んで止まる火花。 */
  pointFromMs: 520, pointGrowMs: 50, burstMs: 320, burstSparkCount: 48, burstSparkLifeMs: [220, 420] as const,
  /** 体の芯から光がこぼれる (f4)。 */
  spillFromMs: 700, spillMs: 500,
  /** 粒が上へ昇る (f5)。体の上から先に・一粒の寿命。体が欠けるのと同じ順・同じ時刻に生まれる (光の裏で消える)。 */
  riseFromMs: 1000, riseSpanMs: 850, particleLifeMs: [700, 1150] as const, particleCount: 1100,
  /** 体が上から欠けて消える (前の消し方・作者 10-30「全体を薄くしていくのでなく、元々やってたみたいに」)。 */
  bodyFadeFromMs: 1000, bodyFadeMs: 900,
  /** 中心の光は体と一緒に細かい粒になって上へ散る。 */
  coreScatterFromMs: 1500, coreScatterMs: 700, coreParticleCount: 160,
  /** 撃破の時計 (止めの後) でここまで来たら勝ちへ (当たりから約 3.0 秒・前は 3.8 秒)。 */
  endFinisherMs: 2900,
} as const
export const STAR = { cutCount: 7, cutStaggerMs: 28, cutLifeMs: 90, starFromClock: 10, starEdgeMs: 22, heavyAtClock: 300, spillMs: 800 } as const
/** 普段の致命の絵。配布版 (lamp) = 入れ替える前の動き execute (剣を頭の上へ弓のように引き、0.5→0.57 秒で奥へ突き込む = 3発目の窓 540ms に重なる)。
 *  作者 (10-20)「通常の地名の方、またなんかくるっと回してポンってやつに戻ってるのね。それじゃなくて、モーションは入れ替える前のやつでいいです。」
 *  swap / swap3 は比べるために止めの深い一突き (execute_finisher) のまま。 */
//   両手の押し込み＋血払い execute_push (scripts/author_lunaire_exec_push.mjs) は比べる版 ?normalExecPose=push だけ。
//   作者 (10-30) の答え「何から指摘していいかわからないぐらいひどいものになってた…元に戻してほしいです」で配布版は execute に戻した。
//   両手で刺して、えぐって、下がりながら引き抜く execute_pull (scripts/author_lunaire_exec_pull.mjs) は比べる版 ?normalExecPose=pull だけ (11-04)。
//     手本 = 通った模型 B・型の絵の答え lean (体を前へ傾ける)・作者 11-04「突き刺してから引き抜くまでを両手でやると重みが出ると思う」。
//     記録 = docs/research/2026-11-04-luna-exec-pull-spine.md。
let execPose: 'execute' | 'push' | 'pull' = 'execute'
export function setNormalExecPose(raw: string | null | undefined): void { execPose = raw === 'push' || raw === 'pull' ? raw : 'execute' }
export function normalExecAnim(): string { return lunaExecLampOn() ? (execPose === 'push' ? 'execute_push' : execPose === 'pull' ? PULL.anim : 'execute') : ALICE.normalAnim }

/** 両手で刺して引き抜く版 (DEV ?normalExecPose=pull) の時刻。ms は致命に入ってからのゲームの経過 (= アニメの秒・止めの間は両方止まる)。
 *  2回目 (11-04 作者「もう少しゆっくりでいいからしっかりと動作がわかるように…重みも感じにくいし動作１つ１つがわかりにくい」):
 *    全体 950→2050ms。刺す 500・押し込む 800・えぐる 1060/1280・抜ける 1580 の間に止めを置く。下がる分はゲームが体を運び、アニメは足が床に着いたまま (travel で打ち消す)。 */
export const PULL = {
  anim: 'execute_pull',
  hitMs: 500,
  hitWindowMs: 70,
  totalMs: 2050,
  /** 刺した瞬間の止め。音と光と揺れは今の普段の致命 (lamp) と同じ。 */
  hitStopMs: 140,
  /** 抜きながら下がる (scripts/author_lunaire_exec_pull.mjs の STEP_PX / STEP_FROM / STEP_TO と同じ)。 */
  stepBackPx: 17, stepFromMs: 1400, stepToMs: 1840,
  /** ボスが崩れ姿のままでいる長さ (当たりからボスの時計で)。剣が抜ける 1580ms (当たりの 1080ms 後) より後まで伏せている。 */
  bossDownAfterHitMs: 1300,
  /** 致命の後の静止 (s)。崩れ姿 1.3 秒＋立ち上がる間 = 主人公が構えに戻った 0.35 秒ほど後に動き出す (今の版と同じ間合い)。 */
  postStillSec: 1.9,
} as const
/** ボスの受け (描画だけ・px・主人公から遠ざかる向きが正)。刺されて押され、押し込みとえぐりで小さく跳ね、抜かれる時に剣へ引かれる。 */
const PULL_BOSS_JOLT: readonly (readonly [number, number])[] = [
  [500, 0], [540, 4], [640, 2.5], [800, 2.5], [880, 5], [1060, 5], [1100, 3.5], [1150, 5],
  [1280, 5], [1320, 6.5], [1370, 5], [1480, 4.5], [1580, -2.5], [1800, 0],
]
export function pullBossJoltPx(elapsedMs: number): number {
  const k = PULL_BOSS_JOLT
  if (elapsedMs <= k[0]![0] || elapsedMs >= k[k.length - 1]![0]) return 0
  for (let i = 1; i < k.length; i++) {
    const [t1, v1] = k[i]!
    if (elapsedMs <= t1) {
      const [t0, v0] = k[i - 1]!
      return v0 + (v1 - v0) * smooth((elapsedMs - t0) / (t1 - t0))
    }
  }
  return 0
}
/** 両手で刺して引き抜く版の普段の致命か。 */
export function pullTimingOn(p: Pick<Player, 'executeVariant'>): boolean {
  return execPose === 'pull' && lunaExecLampOn() && p.executeVariant !== 'finisher'
}
/** 下がった量 (px・0 から stepBackPx へ滑らかに)。 */
export function pullStepBackPx(elapsedMs: number): number {
  return PULL.stepBackPx * smooth((elapsedMs - PULL.stepFromMs) / (PULL.stepToMs - PULL.stepFromMs))
}

/** 普段の致命 (配布版 lamp) の刺した後 (10-29 作者の答え・docs/research/2026-10-29-normal-execute-motion-survey.md)。
 *  「刺されている間は崩れた姿のままでいてほしい」= 3発目の当たりでボスの状態は待機へ戻る (combat.ts) が、絵だけ崩れ姿を保つ。
 *  2回目の答え (10-29)「崩れている時間が短い…もう少し長くしてほしい」= 当たりからボスの時計で bossDownAfterHitMs まで崩れ姿
 *    (主人公が立つ 900ms より後まで伏せている)。致命の後の静止 (combat.ts の stateElapsed -1.1 秒) の内に収める = 崩れ姿のまま攻撃は出ない。
 *    起き上がりの絵はまだ無いので、明けると立ち姿へ切り替わる (起き上がりの絵は Codex で描く・docs/research/2026-10-29-normal-execute-answers-2.md)。
 *  「刺さった瞬間に光ってほしい」= 光の年齢を lightLeadSec だけ先へ進めて出す。止め (190ms) の間は時計が止まり、前は年齢 0 = 何も見えないまま止まっていた。
 *  DEV ?normalExecFix=old = 前の配布版 (当たりで立ち姿・止めが明けてから光る)。 */
export const LAMP_EXEC = {
  bossDownAfterHitMs: 500,
  lightLeadSec: 0.06,
} as const
/** 致命の後の静止の長さ (combat.ts が3発目でボスの stateElapsed を -この秒から始める)。 */
export const POST_EXECUTE_STILL_SEC = 1.1
/** 致命の後の静止 (s)・崩れ姿の長さ (ms)。両手で刺して引き抜く版だけ長い (PULL)。 */
export function postExecuteStillSec(p: Pick<Player, 'executeVariant'>): number { return pullTimingOn(p) ? PULL.postStillSec : POST_EXECUTE_STILL_SEC }
export function lampExecBossDownMs(p: Pick<Player, 'executeVariant'>): number { return pullTimingOn(p) ? PULL.bossDownAfterHitMs : LAMP_EXEC.bossDownAfterHitMs }
let lampFixOld = false
export function setNormalExecFix(raw: string | null | undefined): void { lampFixOld = raw === 'old' }
/** 光の出る時刻を先へずらす秒 (配布版 lamp の普段の致命だけ)。 */
export function lampExecLightLeadSec(): number { return lampFixOld ? 0 : LAMP_EXEC.lightLeadSec }
/** ボスを崩れ姿のまま見せるか (描画だけ)。hold = 崩れ姿のまま／rise = 立ち姿へ混ぜている残り (s)／null = 何もしない。 */
export function lampExecBossHold(player: Pick<Player, 'state' | 'executeVariant' | 'executeHitIndex' | 'attackHitConsumed'>,
  boss: Pick<Boss, 'state' | 'stateElapsed' | 'hp'>): boolean {
  if (lampFixOld || !lunaExecLampOn() || boss.hp <= 0 || player.executeVariant === 'finisher') return false
  // 3発目が当たる前は本物の崩れ姿のまま
  if (player.state === 'executing' && (player.executeHitIndex < EXECUTE.hits - 1 || !player.attackHitConsumed)) return false
  if (boss.state !== 'idle' || boss.stateElapsed >= 0) return false
  return (boss.stateElapsed + postExecuteStillSec(player)) * 1000 < lampExecBossDownMs(player)
}

/** 普段の致命の一突き (直した版だけ)。ms は致命に入ってからのゲームの経過 (1拍の後の 0 から)。
 *  作者 (10-19 Q1)「ちょっと長く感じる…しっかり作り込んでほしい」→ 当たり 540→260ms・全体 900→640ms。絵 = scripts/author_lunaire_exec_thrust.mjs。 */
export const THRUST = {
  anim: 'execute_thrust',
  hitMs: 260,
  /** 当たりを受け付ける幅 (この間に1回)。 */
  hitWindowMs: 70,
  totalMs: 640,
  /** 止めより軽く (普段には重すぎる、の答え)。 */
  hitStopMs: 110,
  shake: { amplitude: 7, durationMs: 200 },
} as const
/** 直した版の普段の致命か (この時だけ THRUST の時計で動く)。 */
export function thrustTimingOn(p: Pick<Player, 'executeVariant'>): boolean {
  return mode === 'swap2' && lunaExecSwapOn() && p.executeVariant !== 'finisher'
}

/** 止め (アリスの技を手本にした版) の時刻。ms はすべて致命に入ってからの見た目の時計 (aliceClockMs)。 */
export const ALICE = {
  anim: 'execute_alice',
  /** 普段の致命に使う絵 = 今の止めの「深く一突き」。 */
  normalAnim: 'execute_finisher',
  /** 当たり = EXECUTE の3発目の窓の頭 (2×240+60)。 */
  hitMs: 540,
  /** 世界が灰色へ沈み始める・沈み切る。 */
  grayInMs: 90,
  grayFullMs: 330,
  grayAmount: 0.85,
  /** 剣先の小さな光 (溜めの終わり)。 */
  glintMs: 300,
  /** 駆け抜け。dashEnd で相手の向こう側に着く。 */
  dashStartMs: 400,
  dashEndMs: 470,
  /** 当たった後の止め (この間だけ時間が止まり、裂け目が順に開く)。 */
  freezeMs: 130,
  cutCount: 6,
  cutStaggerMs: 18,
  cutRevealMs: 34,
  /** 撃破の時計 (finisher.elapsedMs) で: 裂け目が一点へ寄り始める・弾ける。 */
  convergeAtClock: 150,
  burstAtClock: 320,
  /** 相手の体の縁から、どれだけ先まで駆け抜けるか (px)。 */
  passPx: 30,
  wallMarginPx: 80,
} as const

/** 止めの見た目の時計 (ms)。止め (アリスの技) を出していない時は null。
 *  当たるまで = 致命の経過・当たった後 = 当たり + 止めの進み + 撃破の時計 (止めの間も裂け目が開いて見えるよう hitStopRemaining を使う)。 */
export function aliceClockMs(state: Pick<GameState, 'player' | 'finisher' | 'hitStopRemaining'> & { phase?: GameState['phase'] }): number | null {
  if (!lunaExecSwapOn()) return null
  // 勝ちの画面へ移った後は主人公が致命の姿のまま残るので、時計を止める (前は光が当たりの頃へ戻って浮き出ていた・作者 10-30)
  if (state.phase !== undefined && state.phase !== 'playing') return null
  if (state.finisher) {
    const freezeMs = aliceFreezeMs()
    const frozenMs = Math.max(0, freezeMs - Math.max(0, state.hitStopRemaining) * 1000)
    return ALICE.hitMs + Math.min(freezeMs, frozenMs) + state.finisher.elapsedMs
  }
  const p = state.player
  if (p.state !== 'executing' || p.executeVariant !== 'finisher' || p.stateElapsed < 0) return null
  return p.stateElapsed * 1000
}

const smooth = (u: number): number => { const t = Math.max(0, Math.min(1, u)); return t * t * (3 - 2 * t) }

/** 駆け抜けた先 (世界の x)。相手の向こう側・壁の手前で止まる。 */
export function aliceDashTargetX(player: Pick<Player, 'x' | 'facing'>, boss: Pick<Boss, 'x' | 'bodyHalfWidthPx'>,
  bounds: { leftWall: number; rightWall: number }): number {
  const dir = player.facing === 'right' ? 1 : -1
  const want = boss.x + dir * ((boss.bodyHalfWidthPx ?? 40) + ALICE.passPx)
  return Math.max(bounds.leftWall + ALICE.wallMarginPx, Math.min(bounds.rightWall - ALICE.wallMarginPx, want))
}

/** 描く時だけ主人公をずらす量 (px)。ゲームの位置は動かさない (撃破の後は勝ちの画面へ移るので戻さなくてよい)。
 *  向きは変えない = 駆け抜けた後は相手へ背を向けて立つ (手本の残心)。 */
export function aliceDashOffsetPx(clockMs: number | null, player: Pick<Player, 'x' | 'facing'>,
  boss: Pick<Boss, 'x' | 'bodyHalfWidthPx'>, bounds: { leftWall: number; rightWall: number }): number {
  if (clockMs === null || clockMs <= ALICE.dashStartMs) return 0
  const u = (clockMs - ALICE.dashStartMs) / (ALICE.dashEndMs - ALICE.dashStartMs)
  const t = Math.max(0, Math.min(1, u))
  const total = aliceDashTargetX(player, boss, bounds) - player.x
  if (lunaExecSwap3On()) {
    // 重みを足した版: 駆け抜けは速さを保ったまま着き (二乗で緩む = 1コマで飛ばない)、着いてから足を踏ん張って滑り、緩みながら止まる。
    const slide = Math.sign(total) * Math.min(ALICE3.slidePx, Math.abs(total) * 0.3)
    const dash = 1 - (1 - t) * (1 - t)
    const s = Math.max(0, Math.min(1, (clockMs - ALICE.dashEndMs) / (ALICE3.slideEndMs - ALICE.dashEndMs)))
    return (total - slide) * dash + slide * (1 - (1 - s) * (1 - s))
  }
  // 出だしは一瞬で速く、着く前に少しだけ緩む (滑らない・瞬間移動に見せない)
  const e = 1 - (1 - t) * (1 - t) * (1 - t)
  return total * e
}

/** 世界を灰色へ沈める量 (0〜1)。溜めで沈み、駆け出した瞬間に色が戻る。 */
export function aliceGrayAmount(clockMs: number | null): number {
  if (clockMs === null) return 0
  if (clockMs < ALICE.dashStartMs) return ALICE.grayAmount * smooth((clockMs - ALICE.grayInMs) / (ALICE.grayFullMs - ALICE.grayInMs))
  return ALICE.grayAmount * (1 - smooth((clockMs - ALICE.dashStartMs) / 50))
}

/** 直した版の弾けの時刻 (撃破の時計)。作者 (10-19 Q4)「待ち時間が長いのと、ハジケをもっと大きく」。
 *  前の版の 320 は撃破の時計の 150 から先のゆっくり (0.4 倍) の区間に入り、当たりから実時間で約 0.7 秒待っていた。
 *  直した版はゆっくりに入る前 (100) に弾ける = 当たりから止め 130ms + 100ms。 */
export const ALICE2 = { convergeAtClock: 20, burstAtClock: 100 } as const
/** 重みを足した版 (?lunaExec=swap3) の時刻。作者 (10-20 Q1)「安定がないというか重みを感じない」・(Q4)「早送りみたい…ジャキジャキジャキって切っているエフェクトが出て、一瞬止まって…拡散していってボスが倒れて終わる」。
 *  当たりの止めを 130→210ms に伸ばし、裂け目を 18→36ms おきに開く (6本目が開ききるのは当たりから 228ms)。
 *  開ききってから寄り始めるまで約 90ms 静止 (撃破の時計 110)・弾けは 145 (ゆっくり 0.4 倍に入る 150 の手前)。
 *  駆け抜けは着いた後 slidePx だけ踏ん張って滑り、当たりの少し後 (slideEndMs) に止まる。 */
export const ALICE3 = { freezeMs: 210, cutStaggerMs: 36, cutRevealMs: 48, convergeAtClock: 110, burstAtClock: 145, slidePx: 34, slideEndMs: 560 } as const
export function aliceConvergeAtClock(): number { return lunaExecSwap3On() ? ALICE3.convergeAtClock : lunaExecSwap2On() ? ALICE2.convergeAtClock : ALICE.convergeAtClock }
export function aliceBurstAtClock(): number { return lunaExecPierceOn() ? Number.POSITIVE_INFINITY : lunaExecStarOn() ? STAR.heavyAtClock : lunaExecSwap3On() ? ALICE3.burstAtClock : lunaExecSwap2On() ? ALICE2.burstAtClock : ALICE.burstAtClock }
export function aliceFreezeMs(): number { return lunaExecPierceOn() ? PIERCE.freezeMs : lunaExecSwap3On() ? ALICE3.freezeMs : ALICE.freezeMs }
export function aliceCutStaggerMs(): number { return lunaExecSwap3On() ? ALICE3.cutStaggerMs : ALICE.cutStaggerMs }
export function aliceCutRevealMs(): number { return lunaExecSwap3On() ? ALICE3.cutRevealMs : ALICE.cutRevealMs }

/** 撃破の時計で、弾ける拍を跨いだか (音と揺れを1回だけ出す)。 */
export function aliceBurstCrossed(prevClock: number, nextClock: number): boolean {
  const at = aliceBurstAtClock()
  return prevClock < at && nextClock >= at
}
